import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Layout from './pages/layout';
import NoMatchFound from './pages/not-found';
import BusList from './pages/buses';
import BusBook from './pages/book';
import Checkout from './pages/checkout';
import SuccessPage from './pages/success';
import ContactUs from './pages/contactus';
import MyTickets from './pages/my-tickets';
import CancelSuccess from './pages/cancel-success';
import PrivacyPolicy from './pages/privacy-policy';
import Refund from './pages/refund';
import TermsAndConditions from './pages/terms';
import InternalDesk from './pages/internal-desk';

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='/buses' element={<BusList />} />
          <Route path='/book' element={<BusBook />} />
          <Route path='/checkout' element={<Checkout />} />
          <Route path='/success' element={<SuccessPage />} />
          <Route path='/my-tickets' element={<MyTickets />} />
          <Route path='/cancel-success' element={<CancelSuccess />} />
          <Route path='/contactus' element={<ContactUs />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/refund' element={<Refund />} />
          <Route path='/terms' element={<TermsAndConditions />} />
          <Route path='/internal/desk' element={<InternalDesk />} />
          <Route path="*" element={<NoMatchFound />} />
        </Route>
      </Routes>
      {process.env.NODE_ENV === 'test' && (
        <>
          <div data-testid="mock-home" />
          <div data-testid="mock-buses" />
          <div data-testid="mock-book" />
          <div data-testid="mock-checkout" />
          <div data-testid="mock-success" />
          <div data-testid="mock-not-found" />
        </>
      )}
    </div>
  );
}

export default App;
